export const USER_CARD = "USER_CARD";
export const PAY_LOADER = "PAY_LOADER";
export const CREATE_PAYMENT = "CREATE_PAYMENT";
export const PAYMENT_DETAIL = "PAYMENT_DETAIL";
export const CREATE_CUSTOMER = "CREATE_CUSTOMER";
export const CREATE_PAYMENT_INTENT = "CREATE_PAYMENT_INTENT";
export const UPDATE_PAYMENT_STATUS = "UPDATE_PAYMENT_STATUS";
export const CREATE_STRIPE_CUSTOMER = "CREATE_STRIPE_CUSTOMER";
export const PAYMENT_UPDATE_BOOKING = "PAYMENT_UPDATE_BOOKING";
